'use client'
import React from 'react'

import { ApolloProvider } from '@apollo/client';
import { useApollo } from './ApolloClient';


import GlobalLoader from "@/components/GlobalLoader";
function ApolloWrapper({ children }) {

  const client = useApollo();

  return (
    <ApolloProvider client={client}>
  
      {children}

    </ApolloProvider>
  )
}

export default ApolloWrapper